var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-center"},[_c('div',{staticClass:"center clearfix"},[_c('nav-user-center'),_c('div',{staticClass:"right"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }